import React from "react";
import NavBar from "./NavBar";

type Props = {
  children?: React.ReactNode;
  title?: string;
};

export const PageLayout: React.FC<Props> = ({ children, title }) => {
  return <NavBar title={title}>{children}</NavBar>;
};
